import React, { createContext, useContext, useReducer, useEffect } from 'react';

// Počiatočný stav
const initialState = {
  step: 1, // 1: Uvítanie, 2: Osobné údaje, 3: Výber dielne, 4: Rezervácia, 5: Registrácia
  formData: {
    meno: '',
    priezvisko: '',
    ulica: '',
    mesto: '',
    psc: '',
    krajina: 'Slovensko',
    datum_narodenia: '',
    telefon: '',
    email: '',
    email_confirm: '',
    ice: '',
    strava: '',
    ubytko_typ: '',
    dielna_id: null,
    dielna: '',
    platba: '',
    ubytko_pozn: '',
    lek_zaznamy: '',
  },
  dielne: [],
  selectedDielna: null,
  rezervacia: null,
  timeLeft: 120, // Čas na dokončenie rezervácie v sekundách (2 minúty)
  loading: false,
  error: null,
  registrationSuccess: false,
};

// Akcie
const actionTypes = {
  SET_STEP: 'SET_STEP',
  UPDATE_FORM_DATA: 'UPDATE_FORM_DATA',
  SET_DIELNE: 'SET_DIELNE',
  SET_SELECTED_DIELNA: 'SET_SELECTED_DIELNA',
  SET_REZERVACIA: 'SET_REZERVACIA',
  UPDATE_TIME_LEFT: 'UPDATE_TIME_LEFT',
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  RESET_ERROR: 'RESET_ERROR',
  SET_REGISTRATION_SUCCESS: 'SET_REGISTRATION_SUCCESS',
  RESET_STATE: 'RESET_STATE',
};

// Reducer
const registrationReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_STEP:
      return { ...state, step: action.payload };
    case actionTypes.UPDATE_FORM_DATA:
      return { 
        ...state, 
        formData: { ...state.formData, ...action.payload } 
      };
    case actionTypes.SET_DIELNE:
      return { ...state, dielne: action.payload };
    case actionTypes.SET_SELECTED_DIELNA:
      return { ...state, selectedDielna: action.payload };
    case actionTypes.SET_REZERVACIA:
      return { ...state, rezervacia: action.payload };
    case actionTypes.UPDATE_TIME_LEFT:
      return { ...state, timeLeft: action.payload };
    case actionTypes.SET_LOADING:
      return { ...state, loading: action.payload };
    case actionTypes.SET_ERROR:
      return { ...state, error: action.payload };
    case actionTypes.RESET_ERROR:
      return { ...state, error: null };
    case actionTypes.SET_REGISTRATION_SUCCESS:
      return { ...state, registrationSuccess: action.payload };
    case actionTypes.RESET_STATE:
      return { ...initialState, formData: { ...initialState.formData } };
    default:
      return state;
  }
};

// Kontext
const RegistrationContext = createContext();

// Provider komponent
export const RegistrationProvider = ({ children }) => {
  const [state, dispatch] = useReducer(registrationReducer, initialState, () => {
    // Načítanie stavu z lokálneho úložiska
    try {
      const savedState = localStorage.getItem('registrationState');
      return savedState ? JSON.parse(savedState) : initialState;
    } catch {
      return initialState;
    }
  });

  // Uloženie stavu do lokálneho úložiska pri zmene
  useEffect(() => {
    localStorage.setItem('registrationState', JSON.stringify(state));
  }, [state]);

  return (
    <RegistrationContext.Provider value={{ state, dispatch, actionTypes }}>
      {children}
    </RegistrationContext.Provider>
  );
};

// Hook pre použitie kontextu
export const useRegistration = () => {
  const context = useContext(RegistrationContext);
  if (!context) {
    throw new Error('useRegistration must be used within a RegistrationProvider');
  }
  return context;
};
